import axios from 'axios';

const deleteWorkPlaceApi = async (token, id) => {
  const formData = new FormData()
  formData.append('WorkPalace_id', id); 
  try {
    const res = await axios.post(
      '/WorkPalace/delete',
      formData,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'applications/json',
          Authorization: 'Bearer ' + token,
          lang: 'ar'
        }
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export default deleteWorkPlaceApi;
